<template>
    <div class="card">
        <div class="swiper">
            <div class="swiper-wrapper">
                <div class="swiper-slide">
                    <img src="https://via.placeholder.com/600x900" alt="Profile Photo 1" />
                </div>
                <div class="swiper-slide">
                    <img src="https://via.placeholder.com/600x900?text=Photo+2" alt="Profile Photo 2" />
                </div>
                <div class="swiper-slide">
                    <img src="https://via.placeholder.com/600x900?text=Photo+3" alt="Profile Photo 3" />
                </div>
            </div>
            <!-- Pagination -->
            <div class="swiper-pagination"></div>
        </div>

        <div class="overlay">
            <div class="profile-info">
                <h3>Jhon, 25</h3>
                <p>Graphic Designer</p>
            </div>
        </div>

        <div class="action-buttons">
            <button class="btn-round btn-dislike">
                <i class="fa-solid fa-circle-xmark"></i>
            </button>
            <button class="btn-round btn-star">
                <i class="fa-solid fa-star"></i>
            </button>
            <button class="btn-round btn-like">
                <i class="fa-solid fa-heart"></i>
            </button>
        </div>
    </div>
</template>

<script setup>
import { onMounted } from "vue";

onMounted(() => {
    new Swiper(".swiper", {
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });
});
</script>

<style scoped>
.card {
    border-radius: 12px;
    padding: 20px;
    max-width: 400px;
    margin: 5px auto;
    text-align: center;
    color: #fff;
    position: relative;
}

/* Swiper adjustments */
.swiper {
    width: 100%;
    height: 100%;
    border-radius: 0;
    overflow: hidden;
}

.swiper-slide {
    position: relative;
    width: 100%;
    height: 100%;
}

.swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    /* Cover the entire container */
}

/* Overlay with gradient at the bottom */
.overlay {
    position: absolute;
    bottom: 120px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding: 20px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0));
    /* Dark gradient */
    color: white;
    z-index: 10;
    text-align: center;
}

.profile-info h3 {
    margin: 0;
    font-size: 1.8rem;
    font-weight: bold;
}

.profile-info p {
    margin: 5px 0 0;
    font-size: 1rem;
    font-weight: 300;
}

/* Action buttons at the bottom */
.action-buttons {
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 10;
    padding: 20px;
}

.btn-round {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    font-weight: bold;
    color: #fff;
    border: none;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.btn-dislike {
    background: #ff6b6b;
}

.btn-like {
    background: #6bcf63;
}

.btn-star {
    background: linear-gradient(45deg, #7e52d9, #df0774);
    height: 60px;
    width: 60px;
}
</style>
